import { fromJS } from 'immutable';
import { handleActions } from 'redux-actions';

import { getTenantFromUrl } from 'utils/url';

import {
  DECODE_AUTH_TOKEN,
  LOGIN_SUCCESS,
  LOGOUT,
  TICKET_VALIDATION_FAILURE,
} from '../constants';

/**
 * Build the initial authentication state, including a default OEM.
 * @private
 * @returns {object}
 */
export function getInitialState() {
  return fromJS({
    isAuthorized: false,
    tenant: getTenantFromUrl(),
    user: {},
    error: {},
    token: {},
  });
}

function storeAuthData(state, action) {
  const {
    user, // -- this is the actual user account login ID
    authToken,
    authedAt,
    email,
    // isFromNewLogin, -- not used
    // userID, -- seems to always be the same as uuid
    uuid,
  } = action.payload;

  const userInfo = fromJS({
    accessToken: authToken,
    issuedAt: Date.parse(authedAt), // authedAt is in the form '2017-11-21T03:57:46Z'
    email,
    userID: user,
    uuid,
  });

  console.log(`User authorized: ${user}`);

  return state
    .set('isAuthorized', true)
    .set('user', userInfo)
    .set('error', undefined);
}

function storeTokenData(state, action) {
  // action.payload will look something like this:
  // body: {
  //   data: {
  //     attributes: {
  //       email: 'ddaniell@decisiv.net',
  //       exp: 1511363184,
  //       external_id: 'a7b08468-6ea4-11e7-a7eb-0a501d49e77a',
  //       iat: 1511359584,
  //       iss: 'decisiv.com',
  //       name: 'Fleet Web1',
  //       uri: 'decisiv:users:a7b08468-6ea4-11e7-a7eb-0a501d49e77a',
  //       username: 'fleet_web_demo_1',
  //       legacy_tenant: 'vlv',
  //     },
  //     id: 'the JWT token',
  //     type: 'sessions',
  //   },
  // }

  const jwtAttributes = action.payload.body.data.attributes;
  console.log(
    'User token validated:',
    `username=${jwtAttributes.username}`,
    `email=${jwtAttributes.email}`,
    `legacy_tenant=${jwtAttributes.legacy_tenant}`,
    `tenant from URL=${getTenantFromUrl()}`,
  );
  return state.set('token', fromJS(jwtAttributes));
}

function clearAuthData(/* state, action */) {
  return getInitialState();
}

/**
 * Store error information in state regarding a failure to validate a
 * Portunus login ticket.
 */
function handleValidationFailure(state, action) {
  // action.payload will be an object with a `message` and a `code`
  return clearAuthData(state).set('error', fromJS(action.payload));
}

export default handleActions({
  [DECODE_AUTH_TOKEN]: storeTokenData,
  [LOGIN_SUCCESS]: storeAuthData,
  [LOGOUT]: clearAuthData,
  [TICKET_VALIDATION_FAILURE]: handleValidationFailure,
}, getInitialState());



// WEBPACK FOOTER //
// ./features/authentication/redux/reducer.js